// =============================================================================
// locations.js — a location is an id; its name is display text (Oct 2026)
// =============================================================================
// Every location is identified by a permanent id (L########). `schedule.locations`
// lists the ids in display order, `schedule.locationNames` maps each to its name,
// and a slot carries both (`location` = id, `locationName` = name). Everything
// keyed per location -- anchors, skills, types, sites, patterns -- is keyed by id.
// Compare and key by id; SHOW the name. Mirrors src/services/data_service.py.
// =============================================================================

const namesOf = (schedule) => schedule?.locationNames || schedule?.location_names || {};

/** A location's display name (its id if the name is unknown). */
export const locationName = (schedule, id) => namesOf(schedule)[id] || id || '';

/** A slot's location name. */
export const slotLocationName = (shift) =>
  shift?.locationName || shift?.location_name || shift?.location || '';
